import { render, staticRenderFns } from "./main-carousel.component.vue?vue&type=template&id=039f52dc&"
import script from "./main-carousel.component.ts?vue&type=script&lang=ts&"
export * from "./main-carousel.component.ts?vue&type=script&lang=ts&"
import style0 from "./main-carousel.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports